// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3fceu","loaderOuter":"PageOverlayLoader_loaderOuter__GE2RI"};